﻿export const calendarPage = () => {
  const dropdown = document.querySelector("select[data-years]") as HTMLSelectElement | undefined;

  if (!dropdown) {
    console.warn("Missing year selector dropdown");
    return;
  }

  dropdown.addEventListener("change", evt => {
    const selectedYear = (evt.target as HTMLSelectElement).value;

    window.location.href = `${window.location.pathname}?year=${selectedYear}`;
  });
}